import React, { useEffect, useState } from 'react'
import {
    CCard,
    CCardHeader,
    CBadge,
    CTooltip,
    CButton
} from '@coreui/react'
import { cilCommentBubble, cilEnvelopeClosed, cilPencil } from '@coreui/icons'
import CIcon from '@coreui/icons-react'

import CookieFunctions from '../../functions/CookieFunctions';
import { timeOffNames, statusColor } from '../../Constants';
import Table from '../table/table';
import '../../styles/table.css'
import EditRequestModal from './EditRequestModal';
import CreateRequestModal from './CreateRequestModal';
import ResendRequestModal from './ResendRequestModal';
import { toast } from 'react-toastify';


var headers = [
    {
        name: "Type",
        hasSearch: true,
        colSort: true,
    },
    {
        name: "Start Date",
        hasSearch: true,
        colSort: true,
        moreThanJustText: true
    },
    {
        name: "End Date",
        hasSearch: true,
        colSort: true,
        moreThanJustText: true
    },
    {
        name: "Duration",
        hasSearch: true,
        colSort: true,
        moreThanJustText: true
    },
    {
        name: "Approver",
        hasSearch: true,
        colSort: true,
    },
    {
        name: "Comments",
        hasSearch: true,
        colSort: true,
        moreThanJustText: true
    },
    {
        name: "Status",
        hasSearch: true,
        colSort: true,
        moreThanJustText: true
    },
    {
        name: "",
        columnClass: "table-actions",
        moreThanJustText: true
    },
]

export default function AdminAllRequests({ driver }) {
    const [requests, setRequests] = useState(null)
    const [editRequest, setEditRequest] = useState(null)
    const [editVisible, setEditVisible] = useState(false)
    const [newRequestVisible, setNewRequestVisible] = useState(false)
    const [isResendModalVisible, setResendModalVisible] = useState(false);
    const [resendRequestId, setResendRequestId] = useState(null);

    const handleResendButtonClick = (requestId) => {
        setResendRequestId(requestId); // Set the requestId for the ResendRequestModal
        setResendModalVisible(true);
    };

    const handleCloseResendModal = () => {
        setResendModalVisible(false);
    };

    function openEditModal(req) {
        setEditRequest(req)
        setEditVisible(true)
    }

    function closeEditModal() {
        setEditRequest(null)
        setEditVisible(false)
    }

    function getRequests() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();
        formData.append("driverId", driver[0].mpp_id)

        fetch("/api/admin/requests",
            {
                headers: myHeaders,
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setRequests(formatRequests(data));
        })
    }

    function formatRequests(requests) {
        var formattedRequests = requests.map((req, i) => {
            req["Type"] = timeOffNames[driver[0].driver_type][driver[0].country][req["timeOffType"]]
            req["Start Date"] = new Date(req.startDate)
            req["End Date"] = new Date(req.endDate)
            req["Duration"] = parseFloat(req.duration)
            req["Approver"] = req.approver
            req["Comments"] = req.employeeComments
            req["Status"] = req.timeOffStatus
            req["ValueWithElements"] = {
                "Start Date": parseFloat(req.duration) > 0.5 ? req.startDate.split(" ")[0] : req.startDate,
                "End Date": parseFloat(req.duration) > 0.5 ? req.endDate.split(" ")[0] : req.endDate,
                "Duration": parseFloat(req.duration) + " Day(s)",
                "Comments": req.employeeComments !== "" ?
                    <div style={{ display: 'flex', justifyContent: 'center', verticalAlign: 'middle' }}>
                        <CTooltip
                            className='fs-4'
                            content={req.employeeComments}
                            placement="top"
                        >
                            <CIcon icon={cilCommentBubble} />
                        </CTooltip>
                    </div> : null,
                "Status": <CBadge className='fs-6' style={{ color: statusColor[req.timeOffStatus]["text"], backgroundColor: statusColor[req.timeOffStatus]["bg"], justifyContent: 'center', display: 'flex' }} shape='rounded-pill'>{req.timeOffStatus}</CBadge>,
                "": <>
                    <CTooltip content='Edit'>
                        <CButton color='primary' onClick={() => openEditModal(req)} className='m-1'>
                            <CIcon icon={cilPencil} />
                        </CButton>
                    </CTooltip>
                    <CTooltip content='Resend Email'>
                        <CButton color='info' variant='outline' onClick={() => handleResendButtonClick(req.id)} className='m-1' disabled={!(req.timeOffStatus === "Pending Approval" || req.timeOffStatus === "Pending Cancellation")}>
                            <CIcon icon={cilEnvelopeClosed} />
                        </CButton>
                    </CTooltip>
                </>
            }

            return req
        })
        return formattedRequests
    }

    useEffect(() => {
        getRequests()
    }, [driver])

    return (
        <CCard style={{ marginBottom: '1rem' }}>
            <CCardHeader style={{ display: 'flex', justifyContent: "space-between" }}>
                <span style={{ display: 'flex', alignItems: "center" }}>All Requests</span>
                <span>
                    <CButton color='dark' onClick={() => { setNewRequestVisible(true) }}>New Request</CButton>
                </span>
            </CCardHeader>
            <Table headers={headers} body={requests} bordered striped hasSearchRow hasColSort hasPages />
            {editRequest ? <EditRequestModal visible={editVisible} closeModal={closeEditModal} driver={driver} request={editRequest} getRequests={getRequests} /> : null}
            <CreateRequestModal visible={newRequestVisible} closeModal={setNewRequestVisible} driver={driver} getRequests={getRequests} />
            <ResendRequestModal
                visible={isResendModalVisible}
                closeModal={handleCloseResendModal}
                requestId={resendRequestId}
            />
            {/* <CCardFooter className="text-medium-emphasis">2 days ago</CCardFooter> */}
        </CCard >
    )
}